"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIZES_HEIGHTS = void 0;
var _T_SHIRT_SIZES = require("./T_SHIRT_SIZES");
var SIZES_HEIGHTS = Object.freeze({
  sm: _T_SHIRT_SIZES.T_SHIRT_SIZES.sm,
  md: _T_SHIRT_SIZES.T_SHIRT_SIZES.md,
  lg: _T_SHIRT_SIZES.T_SHIRT_SIZES.lg
});
exports.SIZES_HEIGHTS = SIZES_HEIGHTS;